import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

class CartQtyBtn extends Component {

	showQty(){
		if(this.props.qty){
			return <div className="cart-qty-div">{this.props.qty}</div>
		}
	}

	render() {
		return (
			<li>
				<Link className="header_btn" to="/cart">
					{this.showQty()}Cart
				</Link>
			</li>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		qty: state.cart.items.length
	}
}

export default connect(mapStateToProps)(CartQtyBtn)



// WEBPACK FOOTER //
// ./src/components/header/CartQtyBtn.js